module.exports = __webpack_public_path__ + "img/FR14406.c3f3294f.svg";